import React, { useContext } from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'

//Components
import Modal from 'components/Modal'

//Styles
import styles from './AboutModal.module.scss'

//Context
import { InfoContext } from 'context/info-context'

//Types
import { DocsetInfo } from 'types/docset'

export interface Props {
  show: boolean
  onHide: () => void
  info: DocsetInfo
}

const AboutModal = ({show, onHide, info}:Props) => {
  const appInfo = useContext(InfoContext)

  const { t } = useTranslation()

  return (
    <>
      <Modal show={show} onHide={onHide} aboutModal={true}>
        <div className={styles.title} tabIndex={0}>{info.title.long}</div>
        <div className={styles.field}>
          <label className={styles.label} tabIndex={0}>{t('helpcenter-gui-icu.about.field.copyright.label')}</label>
          <span className={styles.value} tabIndex={0}>{info.copyright}</span>
        </div>
        <div className={styles.field}>
          <label className={styles.label} tabIndex={0}>{t('helpcenter-gui-icu.about.field.last_updated.label')}</label>
          <span className={styles.value} tabIndex={0}>{info.updated}</span>
        </div>
        <div className={styles.field}>
          <label className={styles.label} tabIndex={0}>{t('helpcenter-gui-icu.about.field.document_version.label')}</label>
          <span className={styles.value} tabIndex={0}>{info.version}</span>
        </div>
        <div className={styles.field}>
          <label className={styles.label} tabIndex={0}>{t('helpcenter-gui-icu.about.field.app_version.label')}</label>
          <span className={styles.value} tabIndex={0}>{appInfo && appInfo.version}</span>
        </div>
      </Modal>
    </>
  )
}

export default AboutModal